import React, { useState } from 'react';
import { Col, Tabs } from 'antd';
import { FieldArray } from 'formik';

import { WrapperPanel } from 'components';
import { FlexContainer } from 'components/Layout/common';

import AudienceFilters from './AudienceFilters';
import AudienceEssentials from './components/AudienceEssentials';
import AudienceSetup from './components/AudienceSetup';

interface LoyaltyAudienceProps {
  isEditMode?: boolean;
  /** Filter tab only: a host that builds the audience from filters has no file to upload. */
  hideUpload?: boolean;
  essentialsTitle?: string;
}

const tabItems = [
  { label: 'Filter customers', key: 'filter' },
  { label: 'Upload a list', key: 'upload' }
];

const LoyaltyAudience: React.FC<LoyaltyAudienceProps> = ({
  hideUpload = false,
  essentialsTitle = 'Essentials'
}) => {
  const [activeTab, setActiveTab] = useState('filter');
  const items = hideUpload ? tabItems.filter(tab => tab.key !== 'upload') : tabItems;

  return (
    <FlexContainer
      style={{ marginTop: '0', marginBottom: '0' }}
      hasMiddleSpaces
      data-testid="LoyaltyAudience"
    >
      <Col span={24}>
        <WrapperPanel title={essentialsTitle}>
          <AudienceEssentials />
        </WrapperPanel>
        <WrapperPanel title="Audience list">
          {!hideUpload && <Tabs activeKey={activeTab} onChange={setActiveTab} items={items} />}
          {activeTab === 'filter' && <AudienceFilters />}
          {activeTab === 'upload' && !hideUpload && (
            <FieldArray name="user_groups" component={AudienceSetup} />
          )}
        </WrapperPanel>
      </Col>
    </FlexContainer>
  );
};

export default LoyaltyAudience;
